import { IQuestion } from '@/contracts/modules/education/entities/IQuestion'
import { IQuestionRecord } from '@/contracts/modules/education/entities/IQuestionRecord'
import { IQuestionData } from '@/contracts/modules/education/entities/IQuestionData'
import { ISchedule } from '@/contracts/modules/education/entities/ISchedule'
import { EnumWeight } from '@/contracts/modules/education/enum/EnumWeight'

export class Question implements IQuestion {
  /** data — null: ключ или данные не расшифровались */
  constructor(private record: IQuestionRecord, private data: IQuestionData | null) {}

  getUuid(): string {
    return this.record.uuid
  }

  getNode(): string {
    return this.record.node
  }

  getWeight(): EnumWeight {
    return this.record.weight as EnumWeight
  }

  getKey(): string {
    return this.record.key
  }

  getQuestion(): string {
    return this.data?.question ?? ''
  }

  getAnswer(): string {
    return this.data?.answer ?? ''
  }

  getSchedule(): ISchedule {
    return this.record.schedule
  }

  getCreatedAt(): string {
    return this.record.createdAt
  }

  getRemovedAt(): string | null {
    return this.record.removedAt
  }

  isRemoved(): boolean {
    return this.record.removedAt !== null
  }

  isUnreadable(): boolean {
    return this.data === null
  }
}
